function cookieModule () {

	var __ = null

	eventsRun = []

	this.init = function () {

		__ = this

		__.setup()

		var cookies_have_been_set = false

		$('.cookie_setting').each(function () {
			$setting = $(this)
			var cookie_name = $setting.attr('name')
			if (__.get(cookie_name) == 'true') {
				__.run(cookie_name)
				cookies_have_been_set = true
				$('.cookie_setting[name="'+ cookie_name +'"]').prop('checked', true)
			} else {

				if (__.get(cookie_name) != '') {
					var $checkbox = $('.cookie_setting[name="'+ cookie_name +'"]')
					if ($checkbox.prop('disabled') == false) {
						$checkbox.prop('checked', false)
					}
				}
			}
		})

		if (cookies_have_been_set === false) {
			__.show()
		}

		$('.js-open-cookie-settings').on('click', function (e) {
			e.preventDefault()
			__.show()
		})
	}

	this.run = function (event_name)
	{
		if ($.inArray(event_name, eventsRun) === -1 && typeof dataLayer !== 'undefined') {
			dataLayer.push({'event': event_name})
			eventsRun.push(event_name)
		}
	}

	this.set = function (name, value, days = 90) {
		var expires;
	    if (days) {
	        var date = new Date();
	        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
	        expires = "; expires=" + date.toGMTString();
	    } else {
	        expires = "";
	    }
	    document.cookie = encodeURIComponent(name) + "=" + encodeURIComponent(value) + expires + "; path=/";
	}

	this.get = function (cname) {
	  var name = cname + "=";
	  var decodedCookie = decodeURIComponent(document.cookie);
	  var ca = decodedCookie.split(';');
	  for(var i = 0; i <ca.length; i++) {
	    var c = ca[i];
	    while (c.charAt(0) == ' ') {
	      c = c.substring(1);
	    }
	    if (c.indexOf(name) == 0) {
	      return c.substring(name.length, c.length);
	    }
	  }
	  return "";
	}

	this.show = function () {
		$('#cookie-settings-box').fadeIn(200)
	}

	this.hide = function () {
		$('#cookie-settings-box').fadeOut(200)
	}

	this.fullSetup = function () {
		$('.cookie_setting').each(function () {
			$setting = $(this)
			var cookie_name = $setting.attr('name')
			__.run(cookie_name)
			__.set(cookie_name, true)
		})

		__.hide()
	}

	this.customSetup = function () {
		$('.cookie_setting').each(function () {
			$setting = $(this)
			var cookie_name = $setting.attr('name')
			if ($setting.prop('checked') === true) {
				__.run(cookie_name)
				__.set(cookie_name, true)
			} else {
				__.set(cookie_name, false)
			}
		})

		__.hide()
	}

	this.setup = function () {

		var __ = this

		// Toggle checkboxes
		$('#cookie-settings-box').find('.custom-control').on('click', function () {
			var $input = $(this).find('.cookie_setting')
			if ($input.prop('disabled') !== true) {
				if ($input.prop('checked') === true) {
					$input.prop('checked', false)
				} else {
					$input.prop('checked', true)
				}
			}
		})

		$('#accept_cookies').on('click', function (e) {
			e.preventDefault()
			__.fullSetup()
		})

		$('#accept_some_cookies').on('click', function (e) {
			e.preventDefault()
			__.customSetup()
		})
	}
}

module.exports = cookieModule
